import i18n from "@/modules/core/localization/i18n";
import Vue from "vue";
import { BACKEND_URL } from "./index";

import axios from "axios";

import NProgress from "vue-nprogress";
import store from "../store/store";

Vue.use(NProgress, {
  router: true, // Show progressbar when navigating routes, default: true
  http: false, // Show progressbar when doing Vue.http, default: true
});

const nprogress = new NProgress();

axios.defaults.baseURL = BACKEND_URL;
axios.defaults.withCredentials = true;

let isRefreshing = false;
let refreshPromise;

axios.interceptors.request.use(
  function(config) {
    nprogress.start();
    if (store.getters["user/jwt"]) {
      config.headers.common["Authorization"] = `Bearer ${store.getters["user/jwt"]}`;
      config.headers.common["Language"] = store.getters["user/account"].language;
    }

    const deviceId = store.getters["user/deviceId"];
    if (deviceId) {
      config.headers.common["X-Device-Id"] = deviceId;
    }

    const selectedWorkspace = store.getters["switchWorkspace/selected"];
    if (selectedWorkspace) {
      config.headers.common["Workspace"] = selectedWorkspace._id;
    }

    const selectedOrganization = store.getters["organization/selected"];
    if (selectedOrganization) {
      config.headers.common["Organization"] = selectedOrganization._id;
      config.headers.common["Product"] = store.getters["product/currentProduct"];
    }

    return config;
  },
  (error) => {
    nprogress.done();
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    nprogress.done();
    const { status, request } = response;
    if (status === 204 && !request.responseURL.includes("activation") && !request.responseURL.includes("forgot-password")) {
      const app = new Vue();
      app.$toast.error(i18n.t("http.204"));
      return Promise.reject(response);
    }
    return response;
  },
  async function(error) {
    nprogress.done();
    const { response } = error;
    const originalRequest = error.config;

    if (response) {
      const status = response.status;

      if (
        status === 401 &&
        originalRequest &&
        !originalRequest._retry &&
        !originalRequest.url?.includes("/login") &&
        !originalRequest.url?.includes("/refresh-token") &&
        !originalRequest.url?.includes("/logout")
      ) {
        originalRequest._retry = true;
        try {
          if (!isRefreshing) {
            isRefreshing = true;
            refreshPromise = store.dispatch("user/refreshToken");
          }

          await refreshPromise;
          const latestJwt = store.getters["user/jwt"];
          if (latestJwt) {
            originalRequest.headers = originalRequest.headers || {};
            originalRequest.headers["Authorization"] = `Bearer ${latestJwt}`;
          }
          return axios(originalRequest);
        } catch (refreshError) {
          if (window.location.pathname != "/login") {
            store.dispatch("user/logOut");
          }
          return Promise.reject(refreshError?.response || refreshError);
        } finally {
          if (isRefreshing) {
            isRefreshing = false;
            refreshPromise = null;
          }
        }
      }

      if (status === 401) {
        setTimeout(() => {
          if (window.location.pathname != "/login") {
            store.dispatch("user/logOut");
          }
        }, 1000);
      }
    }

    return Promise.reject(response || error);
  }
);
export default axios;
